var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadAgain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 22.7502C14.7299 22.7502 14.4799 22.6002 14.3499 22.3702C14.2199 22.1302 14.2199 21.8502 14.3599 21.6102L15.4099 19.8602C15.6199 19.5002 16.0899 19.3902 16.4399 19.6002C16.7999 19.8102 16.9099 20.2702 16.6999 20.6302L16.4299 21.0802C19.1899 20.4302 21.2599 17.9502 21.2599 14.9902C21.2599 14.5802 21.5999 14.2402 22.0099 14.2402C22.4199 14.2402 22.7599 14.5802 22.7599 14.9902C22.7499 19.2702 19.2699 22.7502 14.9999 22.7502Z",
    fill: "#6A639C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.75C1.59 9.75 1.25 9.41 1.25 9C1.25 4.73 4.73 1.25 9 1.25C9.27 1.25 9.52 1.4 9.65 1.63C9.78 1.87 9.78 2.15 9.64 2.39L8.59 4.14C8.38 4.49 7.92 4.61 7.56 4.39C7.21 4.18 7.09 3.72 7.31 3.36L7.58 2.91C4.81 3.56 2.75 6.04 2.75 9C2.75 9.41 2.41 9.75 2 9.75Z",
    fill: "#6A639C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.8 12.6302V15.5702C14.8 18.0202 13.82 19.0002 11.37 19.0002H8.43C5.98 19.0002 5 18.0202 5 15.5702V12.6302C5 10.1802 5.98 9.2002 8.43 9.2002H11.37C13.82 9.2002 14.8 10.1802 14.8 12.6302Z",
    fill: "#6A639C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.57 5H12.63C10.22 5 9.23996 5.96 9.20996 8.32H11.37C14.31 8.32 15.67 9.69 15.67 12.62V14.78C18.04 14.75 18.99 13.77 18.99 11.36V8.43C19 5.98 18.02 5 15.57 5Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAgain);
export default __webpack_public_path__ + "static/media/upload-again.71dfbb99a87e3f09e9ab07747173ea07.svg";
export { ForwardRef as ReactComponent };